import { List, Record } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';
import YoutubeVideoResourceRecord from './YoutubeVideoResourceRecord';

const keys: Fields = {
  isLoadingPlaylist: false,
  modalIsOpen: false,
  videos: List(),
  error: undefined,
};

interface Fields {
  isLoadingPlaylist: boolean;
  modalIsOpen: boolean;
  videos: List<YoutubeVideoResourceRecord>;
  error?: ErrorRecord;
}

export default class YoutubePlaylistRecord extends Record<Fields>(keys) {
  getIsLoadingPlaylist() {
    return this.isLoadingPlaylist;
  }

  getModalIsOpen() {
    return this.modalIsOpen;
  }

  setVideos(items) {
    return this.set('videos', List(items.map((item) => new YoutubeVideoResourceRecord(item))));
  }

  updateVideoDurations(items) {
    return this.update('videos', (videos) => {
      return videos
        .filter((video) => !!items[video.getVideoId()])
        .map((video) => {
          return video.setVideoDuration(items[video.getVideoId()]);
        });
    });
  }
}
